import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const issueCommentSchema = surrealRecordSchema.extend({
  comment: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type IssueComment = z.infer<typeof issueCommentSchema>;
